<template>
  <section class="about" data-aos="fade-up">
    <h2 class="section-title">Sobre mim</h2>
    <p class="section-subtitle">
      Quem está por trás do Prado's Desenvolvimento Web
    </p>

    <div class="about-grid">
      <div class="about-text">
        <p>
          Meu nome é <strong>Leandro Vinícius do Prado</strong>. Sou
          desenvolvedor web com foco em entregar soluções que realmente
          resolvem problemas de negócio, unindo experiência prática em
          empresas com conhecimento técnico em desenvolvimento de software.
        </p>

        <p>
          Trabalho com <strong>Vue.js</strong>, <strong>C# / .NET</strong>,
          <strong>PHP</strong> e <strong>SQL</strong>, além de integrações com
          APIs bancárias, sistemas de gestão, automações e rotinas de backoffice.
        </p>

        <p>
          Ao longo da minha trajetória, atuei em projetos como integrações
          bancárias (Santander, Bradesco), módulos financeiros,
          dashboards gerenciais, helpdesk, sites institucionais e sistemas
          internos para empresas de diferentes segmentos.
        </p>
      </div>

      <div class="about-panel" data-aos="fade-left" data-aos-delay="150">
        <h3>Principais competências</h3>
        <ul class="about-skills">
          <li>
            <span>Frontend</span>
            <small>Vue.js · SPA · UI responsiva</small>
          </li>
          <li>
            <span>Backend</span>
            <small>C# / .NET · PHP · APIs REST</small>
          </li>
          <li>
            <span>Integrações</span>
            <small>APIs bancárias · NFe · automações</small>
          </li>
          <li>
            <span>Trabalho</span>
            <small>Visão de negócio · atendimento · comunicação</small>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<style scoped>
.about {
  padding: 2.2rem 0 3rem;
}

.about-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 1.2fr);
  gap: 2.5rem;
  align-items: flex-start;
}

.about-text p {
  margin: 0 0 1rem;
  color: var(--pw-muted);
  font-size: 0.95rem;
}

.about-text strong {
  color: #e5e7eb;
}

/* Painel à direita */
.about-panel {
  border-radius: var(--pw-radius-xl);
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: radial-gradient(circle at 0 0, #111827, #020617);
  padding: 1.4rem 1.45rem;
  box-shadow: var(--pw-shadow-soft);
}

.about-panel h3 {
  margin: 0 0 1.1rem;
  font-size: 1rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color:rgba(226, 232, 240, 0.9);
}

.about-skills {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.65rem;
}

.about-skills li {
  padding: 0.55rem 0.7rem;
  border-radius: 14px;
  background: linear-gradient(
    to right,
    rgba(15, 23, 42, 0.9),
    rgba(15, 23, 42, 0.7)
  );
  border: 1px solid rgba(51, 65, 85, 0.8);
}

.about-skills span {
  display: block;
  font-size: 0.88rem;
  font-weight: 500;
  color: #e5e7eb;
}

.about-skills small {
  display: block;
  font-size: 0.78rem;
  color: rgba(148, 163, 184, 0.9);
}

/* Responsivo */
@media (max-width: 960px) {
  .about-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>